module.exports = __webpack_public_path__ + "static/20260818_Fitch_Rating_Report_B-_published-3f511ab00316841fc13dac4017b2b05b.pdf";